<template>
  <div>
    <div class="section-title pb-6 pt-0">Báo cáo chăm sóc</div>
    <v-card style="width: 500px ;">
      <v-card-text class="pa-6">
        <v-select
          item-text="title"
          item-value="value"
          placeholder="Nhân viên sale"
          v-model="user"
          :items="formattedUsers"
          clearable
          outlined
          dense
          hide-details
          @input="handleSelection"
          class="pa-0"
        />
        <PieChart :chartdata="pieChart" :options="pieChartOptions" class="align-self-center" />
        <div class="text-number align-self-center black--text">
          {{ statusCount.countAll }}
        </div>
        <div class="timeline-title align-self-center">
          Khách hàng tiềm năng
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import {mapActions} from 'vuex'
import PieChart from './PieChart.vue'

export default {
  components: {PieChart},
  props: {
    users: Array,
    statusCount: Object
  },
  computed: {
    formattedUsers() {
      return [
        {title: 'Tất cả', value: ''},
        ...this.users.map(u => ({title: u.name ? u.name : u.username, value: u.id}))
      ]
    }
  },
  methods: {
    ...mapActions('lead', ['countStatus']),
    async getPieChartData() {
      return {
        labels: ['Đã chăm sóc', 'Chưa chăm sóc'],
        datasets: [
          {
            backgroundColor: ['#0D47A1', '#BBDEFB'],
            data: [this.statusCount.countAll - this.statusCount.countNoContact, this.statusCount.countNoContact]
          }
        ]
      }
    },
    async updatePieChart() {
      this.pieChart = await this.getPieChartData()
    },
    handleSelection(selectedValue) {
      this.$emit('selected', selectedValue)
    }
  },
  watch: {
    statusCount: {
      deep: true,
      handler() {
        this.updatePieChart()
      }
    }
  },
  data() {
    return {
      pieChartOptions: {responsive: true, maintainAspectRatio: false},
      pieChart: {},
      user: ''
    }
  }
}
</script>

<style scoped>
.text-number {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 900;
  font-size: 28px;
  line-height: 33px;
  text-align: center;
}
.section-title {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 28px;
  color: #212121;
}
.timeline-title {
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 24px;
  color: #757575;
  text-align: center;
}
</style>
